import React, {Component} from "react";
import {Accordion, Card, Carousel, Col, Row} from "react-bootstrap";
// import defaultBillboardImage from "../images/default-billboard.jpeg"
import  {ReactComponent as ArrowSvg} from "../images/arrow.svg"
import  {ReactComponent as EditSvg} from "../images/edit-regular.svg"
import {ContextAwareToggle} from "../bootstrapOverwrites/ContextAwareToggleComponent";
import {ReactComponent as SearchSVG} from "../images/search-solid.svg"
import {ReactComponent as HeartSVG} from "../images/heart.svg"

import {ReactComponent as MapSVG} from "../images/map-marked.svg"

import {Link} from "react-router-dom";
import {CalcOverride, getUrlExtension} from "../helpers/Helpers";
import Axios from "axios";
import {UpdateStatus} from "../helpers/APIWrappers/Campaign";
import moment from "moment";

export default class SelectedBoard extends Component {
    constructor(props) {
        super(props);
        this.complianceAccordionCardHeader = React.createRef();
        this.complianceAccordionCardToggle = React.createRef();
        // this.inputRef.current is null here
    }
    //TODO: This doesn't work. Because board info doesnt scroll. whole side scrolls
    putAtTop = (ev) => {
        let selectBoardContainer = this.selectBoardContainer;
        setTimeout(function (){
            let headerRect = ev.target.getBoundingClientRect();
            let selectBoardContainerRect = selectBoardContainer.getBoundingClientRect();
            // console.log(headerRect.y,  selectBoardContainerRect.y,  selectBoardContainer.scrollTop);
            let scrollDistance = (headerRect.y - selectBoardContainerRect.y) + selectBoardContainer.scrollTop;
            selectBoardContainer.scrollTo({ top: scrollDistance, behavior: 'smooth' });
        },400)
    }

    toggleFavorite = () => {
        let boardId = this.props.boardKey;
        let status = "favorite";
        if (this.props.board.status === 'favorite'){
            status = "";
        }
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/toggle-favorite", {
            boardId: boardId,
            campaignId:this.props.campaign._id,
            status :  status,
        },{
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            let board =  this.props.board;
            board.status = status;
            this.props.updateBoard(boardId,board)
            // this.setState({});
        }).catch(error => {

        });
    }

    updateStatus = (status) => {
        UpdateStatus(this.props.boardKey,this.props.campaign._id,status, (board)=>{
            this.props.updateBoard(this.props.boardKey,board)
        });
    }

    render() {
        let board = this.props.board;
        let override = CalcOverride(board);

        return <div className={"selected-board-container board-card-container"} ref={(el)=>{this.selectBoardContainer=el}}>
            <div className={"selected-card-img-container"} style={{cursor:"pointer"}} >
                <Carousel>
                    {board.images.map(function (im) {
                        return <Carousel.Item>
                            {(()=>{
                                if (getUrlExtension(im) === "pdf") {
                                    return <>
                                        <embed src={im} className={"w-100"} />
                                    </>
                                } else if (im && im.length) {
                                    return <img src={im} alt="billboard header" />
                                }
                            })()}
                        </Carousel.Item>
                    })}
                </Carousel>
                <Row style={{margin:0}}>
                    <Col>
                        <div className={"boring-btn mt-4 d-block font-weight-bold"} style={{width:"fit-content"}} onClick={this.props.toggleFullScreenImage}>Full Screen Images</div>
                    </Col>
                    <Col style={{flexGrow:0}}>
                        <select className={"mt-4 text-capitalize"} value={board.status}
                                disabled={!this.props.isOwner && !(!board.status || board.status === "favorite")}
                                onChange={(ev)=>{
                            this.updateStatus(ev.target.value);
                        }}>
                            <option value={""}></option>
                            <option value={"favorite"}>Favorite</option>
                            {this.props.isOwner ?
                                <>
                                    <option value={"requested"}>Requested</option>
                                    <option value={"unavailable"}>Unavailable</option>
                                    <option value={"confirmed"}>Confirmed</option>
                                    <option value={"posted"}>Posted</option>
                                    <option value={"completed"}>Completed</option>
                                </>
                                :""}
                            {!this.props.isOwner && ![undefined,"","favorite"].includes(board.status) ?
                                <option value={board.status}>{board.status}</option> :""
                            }
                        </select>
                    </Col>
                </Row>
                <div className={"heart-container "+(board.status ==="favorite" ? " favorite":"")}
                     onClick={this.toggleFavorite}
                >
                    <HeartSVG/>
                </div>
            </div>
            <div>
                {/*<p className={"selected-card-title"}>{board.locationDescription}</p>*/}
                {/*<p className={"board-card-subtitle"}>{board.address}</p>*/}
                {/*<p className={"selected-card-subtitle"}>{board.fields["Size (H x W)"]} - {board.fields["Media Format"]}</p>*/}
                <table className={"selected-board-important-fields-table"}>
                    <tbody>
                    {board.fields["end date"] && board.fields["start date"] &&
                        <tr>
                            <th>Flight Dates</th>
                            <td>{moment(board.fields["start date"]).format('M/D/YY')} - {moment(board.fields["end date"]).format('M/D/YY')}</td>
                        </tr>
                    }
                    {["completed","posted"].includes(board.status) ?
                        <>
                            {board.fields["install date"] &&
                                <tr>
                                    <th>Posted on Time</th>
                                    <td>Y</td>
                                </tr>
                            }
                            <tr className={"underline"}></tr>
                            {board.fields["install date"] &&
                                <tr>
                                    <th>Install</th>
                                    <td>{moment(board.fields["install date"]).format('M/D/YY')}</td>
                                </tr>
                            }
                            {board.fields["takedown date"] &&
                                <tr>
                                    <th>Takedown</th>
                                    <td>{moment(board.fields["takedown date"]).format('M/D/YY')}</td>
                                </tr>
                            }
                            {board.fields["install date"] &&
                                <>
                                    <tr className={"underline"}></tr>
                                    <tr>
                                        <th>Override</th>
                                        <td>{override.overridePercent}</td>
                                    </tr>
                                    <tr>
                                        <th>Override Media Value</th>
                                        <td>${override.overrideMediaValue}</td>
                                    </tr>
                                    <tr>
                                        <th>Bonus Impressions</th>
                                        <td>{override.bonusImpressions}</td>
                                    </tr>
                                </>

                            }
                            <tr className={"underline"}></tr>
                        </>
                        :
                        <tr className={"underline"}></tr>
                    }
                    <tr>
                        <th>Size (H x W)</th><td>{board.fields["h x w"] ? board.fields["h x w"] : board.fields["size (h x w)"]}</td>
                    </tr>
                    <tr className={"underline"}>
                        <th>Media Format</th>
                        <td>
                        <span className={
                            "media-format "+(board.fields["media format"] ? board.fields["media format"].toLowerCase() : "")
                            + (board.fields["digital (y/n)"] === "Y" ? " digital": "")
                        }
                        />
                            {board.fields["digital (y/n)"] === "Y" ? "Digital ": ""}
                            {board.fields["media format"]}
                        </td>
                    </tr>
                    {
                        board.fields["neg rate"] ? <tr>
                            <th>4-Wk Media Cost</th><td>${board.fields["neg rate"]}</td>
                        </tr>:<></>
                    }
                    {
                        board.fields["4-wk media cost"] ? <tr>
                            <th>4-Wk Media Cost</th><td>${board.fields["4-wk media cost"]}</td>
                        </tr>:<></>
                    }

                    {
                        board.fields["4-wk imp"] ? <tr className={"underline"}>
                            <th>4-Wk Impressions</th><td>{board.fields["4-wk imp"]}</td>
                        </tr>:<></>
                    }
                    {
                        board.fields["4-wk impressions"] ? <tr className={"underline"}>
                            <th>4-Wk Impressions</th><td>{board.fields["4-wk impressions"]}</td>
                        </tr>:<></>
                    }
                    {
                        board.fields["cpm"] ? <tr className={"underline"}>
                            <th>CPM</th><td>${Math.round(board.fields["cpm"] * 100)/100}</td>
                        </tr> : <></>
                    }
                    {
                        board.fields["4-wk trp"] ? <tr className={"underline"}>
                            <th>4-Wk TRP</th><td>${Math.round(board.fields["4-wk trp"] * 100)/100}</td>
                        </tr> : <></>
                    }
                        <tr>
                            <td style={{textAlign:"left"}}>
                                <a target={"_blank"} className={"boring-btn"} rel="noreferrer" href={`https://www.google.com/maps/place/?q=${board.lat},${board.lon}`}>
                                    <SearchSVG/> Open in Maps
                                </a>
                            </td>
                            <td>
                                {this.props.campaign.complianceOn  ?
                                    <>
                                        {board.complianceArray && board.complianceArray.length ?
                                            <div className={"red-btn ft-md compliance-badge"} onClick={()=>{
                                                this.complianceAccordionCardToggle.current.click();
                                            }}>Compliance</div> :
                                            <div className={"green-btn ft-md compliance-badge"} onClick={()=>{
                                                this.complianceAccordionCardToggle.current.click();
                                            }}>Compliance</div>
                                        }
                                    </>:<></>}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Accordion>
                <Card>
                    {/*<Accordion.Toggle as={Card.Header} eventKey="0">*/}
                    {/*    Metadata*/}
                    {/*</Accordion.Toggle>*/}
                    <Card.Header>
                        {/*<Accordion.Toggle as={Card.Header} eventKey="2" onClick={()=>{this.props.togglePOIsPins()}}>*/}
                        <ContextAwareToggle
                            eventKey="0"
                            clickEvent={(ev)=>{this.putAtTop(ev);this.props.turnOffPins();}}
                        >Metadata <ArrowSvg className={"accordion-arrow"}/></ContextAwareToggle>
                        {/*</Accordion.Toggle>*/}
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            <table className={"selected-card-accordion-table"}>
                                <tbody>
                                {
                                    Object.keys(board.fields).map((key, index) => {
                                        if(!this.props.isOwner && this.props.campaign.hiddenFields.includes(key)){
                                            return <></>
                                        }
                                        if(Number.isInteger(board.fields[key]) && key === "start" && key === "start date" && key === "end" && key === "end date"){
                                            let d =  new Date(Math.round((board.fields[key] - 25569)*86400*1000))
                                            board.fields[key] = (d.getMonth()+1) + "/" + d.getDate();
                                        }
                                        return <tr key={index}>
                                            <th>{key}</th>
                                            <td>
                                                <div>{board.fields[key]}</div>
                                            </td>
                                        </tr>
                                    })
                                }
                                </tbody>
                            </table>
                            {this.props.isOwner ?
                                <div className={"text-center mt-3"}>
                                    <Link target={"_blank"} className={"boring-btn"} to={`/campaigns/${this.props.campaign._id}/edit-board?board=${escape(this.props.boardKey)}`}><EditSvg/> Edit</Link>
                                </div> : <></>
                            }
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                {this.props.campaign.complianceOn ?
                    <Card>
                        {/*<Accordion.Toggle as={Card.Header} eventKey="1" onClick={()=>{this.props.toggleCompliancePins()}}>*/}
                        {/*    Compliance*/}
                        {/*</Accordion.Toggle>*/}
                        <Card.Header>
                            {/*<Accordion.Toggle as={Card.Header} eventKey="2" onClick={()=>{this.props.togglePOIsPins()}}>*/}
                            <ContextAwareToggle
                                eventKey="1"
                                refForDiv={this.complianceAccordionCardToggle}
                                clickEvent={(ev)=>{this.putAtTop(ev);this.props.toggleCompliancePins()}}>
                                Compliance <ArrowSvg className={"accordion-arrow"}/>
                            </ContextAwareToggle>
                            {/*</Accordion.Toggle>*/}
                        </Card.Header>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div className={"compliance-accordion"}>
                                    {board.complianceArray && board.complianceArray.length ?
                                        board.complianceArray.map((c,i) =>
                                            <div key={i} className={"compliance-issue-container"}>
                                                <div className={"compliance-left"}>
                                                    <div className={"compliance-name"}>{c.name}</div>
                                                    <div className={"compliance-category"}>{c.category}</div>
                                                </div>
                                                <div className={"compliance-distance"}>{PrettyDistance(c.distance)}
                                                    {(() => {
                                                        if(c["place_id"]){
                                                            return <a target={"_blank"} rel="noreferrer" href={"https://www.google.com/maps/place/?q=place_id:"+c["place_id"]} className={"to-maps-btn"}>
                                                                <SearchSVG/>
                                                            </a>
                                                        }else if(c["address"]){
                                                            return <a target={"_blank"} rel="noreferrer" href={"https://www.google.com/maps/place/?q="+c["address"]} className={"to-maps-btn"}>
                                                                <SearchSVG/>
                                                            </a>
                                                        }else{
                                                            return <a target={"_blank"} rel="noreferrer" href={`https://www.google.com/maps/place/?q=${c.lat},${c.lon}`} className={"to-maps-btn"}>
                                                                <SearchSVG/>
                                                            </a>
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                        ) :
                                        <i>No Compliance Issues Found</i>
                                    }
                                    {this.props.isOwner ?
                                        <div className={"text-center mt-3"}>
                                            <Link target={"_blank"} className={"boring-btn"} to={`/campaigns/${this.props.campaign._id}/edit-board?board=${escape(this.props.boardKey)}`}><EditSvg/> Edit</Link>
                                        </div> : <></>
                                    }
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    :
                    <></>
                }
                {/*<Card>*/}
                {/*    <Card.Header>*/}
                {/*    /!*<Accordion.Toggle as={Card.Header} eventKey="2" onClick={()=>{this.props.togglePOIsPins()}}>*!/*/}
                {/*        <ContextAwareToggle*/}
                {/*            eventKey="2"*/}
                {/*            clickEvent={(ev)=>{this.putAtTop(ev);this.props.togglePOIsPins();}}>*/}
                {/*            POIs <ArrowSvg className={"accordion-arrow"}/>*/}
                {/*        </ContextAwareToggle>*/}
                {/*    /!*</Accordion.Toggle>*!/*/}
                {/*    </Card.Header>*/}
                {/*    <Accordion.Collapse eventKey="2">*/}
                {/*        <Card.Body>*/}
                {/*            <div className={"compliance-accordion"}>*/}
                {/*                {board.poisArray && board.poisArray.length ?*/}
                {/*                    board.poisArray.map((c,i) =>*/}
                {/*                        <div key={i} className={"compliance-issue-container"}>*/}
                {/*                            <div className={"compliance-left"}>*/}
                {/*                                <div className={"compliance-name"}>{c.name}</div>*/}
                {/*                                <div className={"compliance-category"}>Query: {c.category}</div>*/}
                {/*                            </div>*/}
                {/*                            <div className={"compliance-distance"}>{getMiles(c.distance)}Mi*/}
                {/*                                {(() => {*/}
                {/*                                    if(c["place_id"]){*/}
                {/*                                        return <a target={"_blank"} rel="noreferrer" href={"https://www.google.com/maps/place/?q=place_id:"+c["place_id"]} className={"to-maps-btn"}>*/}
                {/*                                            <SearchSVG/>*/}
                {/*                                        </a>*/}
                {/*                                    }else if(c["address"]){*/}
                {/*                                        return <a target={"_blank"} rel="noreferrer" href={"https://www.google.com/maps/place/?q="+c["address"]} className={"to-maps-btn"}>*/}
                {/*                                            <SearchSVG/>*/}
                {/*                                        </a>*/}
                {/*                                    }else{*/}
                {/*                                        return <a target={"_blank"} rel="noreferrer" href={`https://www.google.com/maps/place/?q=${c.lat},${c.lon}`} className={"to-maps-btn"}>*/}
                {/*                                            <SearchSVG/>*/}
                {/*                                        </a>*/}
                {/*                                    }*/}
                {/*                                })()}*/}
                {/*                            </div>*/}
                {/*                        </div>*/}
                {/*                    ) :*/}
                {/*                    <i>No POIs Found</i>*/}
                {/*                }*/}
                {/*                {this.props.isOwner ?*/}
                {/*                    <div className={"text-center mt-3"}>*/}
                {/*                        <Link target={"_blank"} className={"boring-btn"} to={`/campaigns/${this.props.campaign._id}/edit-board?board=${this.props.boardKey}`}><EditSvg/> Edit</Link>*/}
                {/*                    </div> : <></>*/}
                {/*                }*/}
                {/*            </div>*/}
                {/*        </Card.Body>*/}
                {/*    </Accordion.Collapse>*/}
                {/*</Card>*/}
            </Accordion>
        </div>;
    }
}
function PrettyDistance(i) {
    let f = i * 3.28084;
    if(f < 1000){
        return  Math.round(f) + "Ft";
    }
    let m = i * 0.000621371192;
    //if under 1k feet return feet
    return Math.round(m * 100) / 100 +"Mi"
}
